import Link from "next/link";

import IconArrowRight18 from "@assets/svg/IconArrowRight18";
import IconCheckCircle from "@assets/svg/IconCheckCircle";
import Text from "@/blueprint/components/Text/Text";
import { CHROME_THEME_FADE_CLASSES } from "@/blueprint/tokens/Motion";
import { useTrack } from "@/analytics/events";
import { ANNOUNCEMENT, type Announcement } from "@/chrome/chromeContent";
import { cn } from "@/lib/utils";

/* Gaps and icon sizes hold at every breakpoint, where the spacing tokens
   re-point, so they are literal px. A page can pass its own line; the site's
   is the default. */
const AnnouncementBar = ({
  content = ANNOUNCEMENT,
}: {
  content?: Announcement;
}) => {
  const track = useTrack();

  return (
    <aside aria-label="Announcement" className="px-grid-margin">
      <Link
        href={content.href}
        onClick={() => track("announcement_clicked", { href: content.href })}
        className={cn(
          "flex min-h-[56px] items-center justify-center gap-[4px] border-b border-stroke text-content-primary sd:min-h-[64px] d:min-h-[72px]",
          CHROME_THEME_FADE_CLASSES,
        )}
      >
        {/* pt-[2px] drops PP Mori's high-sitting ink onto the icons' centre. */}
        {content.lead !== null && (
          <Text
            variant="paragraph-sm"
            as="span"
            tone="inherit"
            className="hidden pt-[2px] tab:inline"
          >
            {content.lead}
          </Text>
        )}
        <span className="flex items-center gap-[2px]">
          {content.checkmark && (
            <IconCheckCircle className="size-[18px] shrink-0" />
          )}
          <Text
            variant="paragraph-sm"
            as="span"
            tone="inherit"
            className="pt-[2px]"
          >
            {content.detail}
          </Text>
        </span>
        <IconArrowRight18 className="size-[18px] shrink-0" />
      </Link>
    </aside>
  );
};

export default AnnouncementBar;
